
function bsAlert(message: string | JQuery<HTMLElement>, title = 'MedModus', type: string = BootstrapDialog.TYPE_PRIMARY) {
    BootstrapDialog.alert({
        message: typeof (message) == 'string' ? sanitizeHtml(message) : message,
        title: title,
        type: type,
    });
}

function bsConfirm(message: string, onOk: () => void, title = 'MedModus', type: string = BootstrapDialog.TYPE_PRIMARY) {
    BootstrapDialog.show({
        message: sanitizeHtml(message),
        type: type,
        title: title,
        closable: false,
        buttons: [
            {
                label: _ls('OK'),
                cssClass: 'btn-primary',
                action: function (this: BootstrapDialogButton, dlg: BootstrapDialog) {
                    dlg.close();
                    onOk();
                }
            },
            {
                label: _ls('Cancel'),
                cssClass: 'btn-secondary',
                action: function (dlg: BootstrapDialog) {
                    dlg.close();
                }
            }
        ]
    });
}

function bsDialogExtendBasicSettings(settings: BootstrapDialogSettings) {
    const basicSettings = {
        nl2br: false,
        spinicon: 'fas fa-asterisk',
    };
    if (settings.nl2br == undefined) {
        settings.nl2br = basicSettings.nl2br;
    }
    if (settings.spinicon == undefined) {
        settings.spinicon = basicSettings.spinicon;
    }
    if (settings.buttons) {
        if (!settings.onlyDefinedButtons) {
            settings.buttons.push({
                label: _ls('Cancel'),
                cssClass: 'btn-secondary',
                action: function (dlg) {
                    dlg.close();
                }
            });
        }

        if (settings.size == BootstrapDialog.SIZE_WIDE && settings.buttons) {
            // add btn-lg to each button class to prevent full-width buttons
            settings.buttons.forEach((btn, i) => {
                if (settings.buttons) {
                    const curBtn = settings.buttons[i];
                    if (!curBtn.cssClass) {
                        curBtn.cssClass = '';
                    }
                    curBtn.cssClass += ' btn-lg';
                }
            });
        }
    }
    return settings;
}

function bsDialogBasic(settings: BootstrapDialogSettings) {
    return BootstrapDialog.show(bsDialogExtendBasicSettings(settings));
}

function createAutoClosingAlert(selector: string, delay = 3000) {
    const $alert = $(selector);
    $alert.show('fast');
    window.setTimeout(function () { $alert.hide('fast'); }, delay);
}

function beginAjaxLoading() {
    $('.ajax-loading').fadeIn('fast');
}

function endAjaxLoading() {
    $('.ajax-loading').fadeOut('fast');
}

// TODO: these GET requests are silent, and this is not always needed
function ajaxGetText(url: string, onSuccess: (text: string) => void, onError?: () => void) {
    $.ajax(url, {
        method: 'GET',
        dataType: 'text',
        global: false,
        error: onError,
        success: onSuccess,
    });
}

function ajaxGetHtml(url: string, onSuccess: (html: string) => void) {
    $.ajax(url, {
        method: 'GET',
        dataType: 'html',
        success: onSuccess,
    });
}

function ajaxGetJsonFile(url: string, onSuccess: (json: object) => void, silent = false) {
    $.ajax(url, {
        method: 'GET',
        global: !silent,
        dataType: 'json',
        success: onSuccess,
    });
}

function ajaxPostMultipart(url: string, formData: FormData, onSuccess: (result: any) => void) {
    $.ajax({
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST',
        success: onSuccess
    });
}

// Request is form-encoded and available as separate arguments of controller method
function ajaxPostForm(url: string, data: string | object | undefined, onSuccess: (result: any) => void, silent = false, onError: (() => void) | undefined = void (0)) {
    const args = {
        type: 'POST',
        url: url,
        data: getObjectWithVerificationToken(data),
        success: onSuccess,
        error: onError
    };
    if (silent) {
        (args as any).global = false;
        (args as any).error = function () {
            // report about AJAX errors
            bsAlert('AJAX request error!');
        };
    }
    $.ajax(args);
}

// Request is JSON-encoded and available as [FromBody] argument of controller method
function ajaxPostJson(url: string, data: string | object | undefined, onSuccess: (result: any) => void, silent = false) {
    const antiForgeryToken = <string>$("*[name='__RequestVerificationToken']").first().val();
    const args = {
        type: 'POST',
        url: url,
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: onSuccess,
        headers: {
            'RequestVerificationToken': antiForgeryToken
        }
    };
    if (silent) {
        (args as any).global = false;
        (args as any).error = function () {
            // report about AJAX errors
            bsAlert('AJAX request error!');
        };
    }
    $.ajax(args);
}

function ajaxGetJson(url: string, data: string | object | undefined, onSuccess: (result: any) => void, silent = false, headers?: JQuery.PlainObject<string | null | undefined>) {
    $.ajax({
        type: 'GET',
        url: url,
        data: data,
        contentType: 'application/x-www-form-urlencoded; charset=utf-8',
        dataType: 'json',
        success: onSuccess,
        global: !silent,
        headers,
        error: function () {
            // report about AJAX errors
            bsAlert('AJAX request error!');
        }
    });
}

function escapeHtml(text: string): string {
    const escapedChars = {
        '"': '&quot;', '&': '&amp;', "'": '&#39;',
        '/': '&#47;', '<': '&lt;', '>': '&gt;'
    };
    const chrs: { [key: string]: string } = escapedChars;

    return text.replace(/["&'/<>]/g, function (a: string): string {
        return chrs[a] as any;
    });
}

function sanitizeHtml(html: string) {
    function trimAttributes(node: Element) {
        $.each(node.attributes, function () {
            const attrName = this.name;
            const attrValue = this.value;

            // remove attribute name start with "on", possible unsafe,
            // for example: onload, onerror...
            //
            // remvoe attribute value start with "javascript:" pseudo protocol, possible unsafe,
            // for example href="javascript:alert(1)"
            if (attrName.indexOf('on') == 0 || attrValue.indexOf('javascript:') == 0) {
                $(node).removeAttr(attrName);
            }
        });
    }

    // parse html in a new document context, removing scripts
    const output = $($.parseHTML('<div>' + html + '</div>', null, false));
    output.find('*').each(function () {
        trimAttributes(<Element><unknown>this);
    });
    return output.html();
}

function makeIdsUnique(html: string) {
    function replaceAll(str: string, find: string, replace: string) {
        return str.replace(new RegExp(find, 'g'), replace);
    }

    // making id attributes unique by appending an underscore
    const matches = html.match(/id="([^"]+)"/g);
    if (matches) {
        matches.forEach((idAttr) => {
            // replace corresponding attribute values - not only [id], but also [for].
            const idMatches = idAttr.match(/"([^"]+)"/);
            if (idMatches && idMatches.input) {
                const newInputId = idMatches.input.replace(idMatches[1], idMatches[1] + '_');
                html = replaceAll(html, idMatches.input, newInputId);
                html = replaceAll(html, idMatches.input.replace('id', 'for'), newInputId.replace('id', 'for'));
                // fix of tabs href to id
                html = replaceAll(html, `#${idMatches[1]}`, `#${idMatches[1]}_`);
            }
        });
    }

    return html;
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class BsTabs {
    public static activateTabs($container: JQuery) {
        $container.find('> .nav-tabs').on('click', 'a', function (e) {
            const $tab = $(this).parent();
            BsTabs.switchToTab($container, $tab);
        });
    }

    public static switchToTab($container: JQuery, $tab: JQuery) {
        const tabIndex = $tab.index(),
            $tabPane = $container.find('> .tab-content > .tab-pane').eq(tabIndex);
        $container.find('> .tab-content > .tab-pane.active, > .nav-tabs .active').removeClass('active');
        $tabPane.addClass('active');
        $tab.find('a').addClass('active');
    }

    public static switchToInvalidTab($tabbedForm: JQuery) {
        const $invalidControls = $tabbedForm.find('> .tab-content .is-invalid');
        if ($invalidControls.length > 0) {
            const $tabPane = $($invalidControls[0]).closest('.tab-pane'),
                tabIndex = $tabPane.index();
            $tabbedForm.find('> .tab-content > .tab-pane.active, > .nav-tabs .active').removeClass('active');
            $tabPane.addClass('active');
            $tabbedForm.find('.nav-tabs LI').eq(tabIndex).find('.nav-link').addClass('active');
        }
    }
}

function validatorSetDefaults() {
    $.validator.setDefaults({
        errorElement: 'div',
        errorClass: 'form-text text-danger',
        highlight: function (element: HTMLElement, errorClass: string, validClass: string) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element: HTMLElement, errorClass: string, validClass: string) {
            $(element).removeClass('is-invalid');
        },
        errorPlacement: function ($error: JQuery, $element: JQuery) {
            // TODO: Improve this code to support groups of radios or checkboxes
            const $parent = $element.parent();
            if ($parent.is('.input-group') || $parent.is('.btn-group') || $parent.is('.bootstrap-select')
                || $element.prop('type') === 'checkbox' || $element.prop('type') === 'radio') {
                $error.insertAfter($element.parent());
            }
            else {
                $error.insertAfter($element);
            }
        }
    });
}

function isHTML(str: string) {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

$.fn.extend({
    findCtrl: function (this: JQuery, name: string) {
        return this.find('[name="' + $.escapeSelector(name) + '"]');
    },

    filterByData: function (this: JQuery, prop: string, val?: string | number | boolean | null) {
        const $self = this;
        if (typeof val === 'undefined') {
            return $self.filter(
                function () { return typeof $(this).data(prop) !== 'undefined'; }
            );
        }
        return $self.filter(
            function () { return $(this).data(prop) == val; }
        );
    },

    // jQuery plugin to check if an element is in the selector's viewport
    isInViewport: function (this: JQuery, container: string) {
        const element = this.get(0);
        if (!element) {
            return false;
        }
        const containerElement = $(container).get(0);
        const rect = element.getBoundingClientRect();
        const containerRect = containerElement.getBoundingClientRect();
        return (
            rect.top >= containerRect.top &&
            rect.left >= containerRect.left &&
            rect.bottom <= containerRect.bottom &&
            rect.right <= containerRect.right
        );
    }
});

function getObjectWithVerificationToken(src: any = null): any {
    const token = <string>$("*[name='__RequestVerificationToken']").first().val();
    if (src == null) {
        return { __RequestVerificationToken: token };
    }
    if (typeof src === 'object') {
        src.__RequestVerificationToken = token;
    }
    return src;
}

function formToObject($form: JQuery): { [key: string]: any } {
    const array = $form.serializeArray();
    const obj: { [key: string]: any } = {};

    $.map(array, function (elem, i) {
        obj[elem['name']] = elem['value'];
    });

    return obj;
}

function objectToForm($form: JQuery, obj: { [key: string]: any }) {
    for (const key in obj) {
        $form.findCtrl(key).val(obj[key]);
    }
}

function makeFormReadonly($form: JQuery) {
    $form.find('INPUT, SELECT, TEXTAREA').each(function () {
        const $ctrl = $(this);
        $ctrl.prop('disabled', true);
        if ($ctrl.data('selectpicker')) {
            $ctrl.selectpicker('refresh');
        }
    });
}

function cloneObject<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
}

function trackHashChanges(onChange: (hash: string, oldHash: string) => void) {
    function getCurrentHash() {
        return location.hash.replace(/^#/, '');
    }

    const hashesQueue = $({}); // queue from an empty JQ object
    let oldHash = '',
        ajaxActive = false;
    $(document).ajaxStop(function () {
        ajaxActive = false;
        // process next hash change
        hashesQueue.dequeue();
    });
    $(document).ajaxStart(function () {
        ajaxActive = true;
    });

    onChange(getCurrentHash(), oldHash);
    $(window).on('hashchange', function (e) {
        // TODO: custom named queue does not work for some reason
        hashesQueue.queue(function () {
            onChange(getCurrentHash(), oldHash);
            oldHash = getCurrentHash();

            // move to next hash change if AJAX has not started, otherwise wait for AJAX stop
            if (!ajaxActive) {
                hashesQueue.dequeue();
            }
        });
    });
}

function setCookie(name: string, value: string, days: number) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name: string) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

function eraseCookie(name: string) {
    document.cookie = name + '=; path=/; Max-Age=-99999999;';
}

function addUrlParam(key: string, value: string) {
    if (window.location.search.includes(key)) {
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(key, value);
    if (window.history.pushState) {
        const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + urlParams.toString();
        window.history.pushState({ path: newurl }, '', newurl);
    }
}

function getUrlParam(name: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

interface Window {
    LocalizedStrings: { [controller: string]: { [locale: string]: { [key: string]: string } } };
    InAdminArea: boolean | undefined;
    ControllerName: string | undefined;
}

function _ls(key: string, defaultStr?: string): string {
    const defaultString = defaultStr ?? key;
    const fallbackCulture = 'en-GB';
    const fallbackLanguage = 'en';

    if (window.LocalizedStrings) {
        let culture = fallbackCulture;
        let language = fallbackLanguage;
        if (!window.InAdminArea) {
            // load culture id from cookie if not in admin area
            const cultureCookie = decodeURIComponent(getCookie('.AspNetCore.Culture'));
            if (cultureCookie) {
                try {
                    culture = cultureCookie.split('|')[0].split('=')[1];
                    language = culture.split('-')[0];
                }
                catch { }
            }
        }

        let strings: { [key: string]: string } = {};
        if (window.ControllerName) {
            // search for controller-specific localized string
            const controllerDictionaries = window.LocalizedStrings[window.ControllerName + 'Controller'];

            if (controllerDictionaries) {
                if (controllerDictionaries[culture]) {
                    strings = controllerDictionaries[culture];
                }
                else if (controllerDictionaries[language]) {
                    strings = controllerDictionaries[language];
                }

                if (strings[key]) {
                    return strings[key];
                }
            }
        }

        const sharedDictionaries = window.LocalizedStrings['PortalSharedResources'];
        if (sharedDictionaries) {
            // search for shared localized string
            // TODO: this block repeats the code above, refactor?
            if (sharedDictionaries[culture]) {
                strings = sharedDictionaries[culture];
            }
            else if (sharedDictionaries[language]) {
                strings = sharedDictionaries[language];
            }

            if (strings[key]) {
                return strings[key];
            }
        }

        // return string from shared dictionary of fallback culture
        if (culture != fallbackCulture && sharedDictionaries && sharedDictionaries[fallbackCulture]) {
            strings = sharedDictionaries[fallbackCulture];
        }
        else if (language != fallbackLanguage && sharedDictionaries && sharedDictionaries[fallbackLanguage]) {
            strings = sharedDictionaries[fallbackLanguage];
        }

        return strings[key] ? strings[key] : defaultString;
    }
    return defaultString;
}

function formatString(template: string, values: any[]) {
    return template.replace(/{(\d+)}/g, (match, indexStr) => {
        const index = parseInt(indexStr, 10);
        return values[index] !== undefined ? values[index] : match;
    });
}

interface String {
    lowerCaseFirst: () => string;
    shortenIfLong: (maxLength: number, ellipsis?: string) => string;
}

String.prototype.lowerCaseFirst = String.prototype.lowerCaseFirst || function (this: string) {
    return this.charAt(0).toLowerCase() + this.slice(1);
};

String.prototype.shortenIfLong = String.prototype.shortenIfLong || function (this: string, maxLength: number, ellipsis: string | null = null) {
    return this.length > maxLength ? this.substring(0, maxLength - 1).trim() + (ellipsis ?? '...') : this;
};


interface Array<T> {
    swapItems(a: number, b: number): Array<T>;
    distinct(): Array<T>;
}

if (!Array.prototype.swapItems) {
    Array.prototype.swapItems = function (a, b) {
        this[a] = this.splice(b, 1, this[a])[0];
        return this;
    };
}

if (!Array.prototype.distinct) {
    Array.prototype.distinct = function () {
        return this.filter(onlyUnique);
    };

    const onlyUnique = (value: string, index: number, self: string[]) => {
        return self.indexOf(value) === index;
    };
}

function activateSidebarMenu() {
    const $body = $('body'),
        $aside = $('#aside'),
        $asideNavbar = $('#asideNavbar');

    if ($aside.length > 0) {
        const toggleSidebarMenu = () => {
            $body.toggleClass('sidebar-mini');
            $('#asideBtn A').toggleClass('mini');
            $asideNavbar.find('.nav > li div').removeClass('active');

            document.cookie = 'SideMenuState=' + ($body.hasClass('sidebar-mini') ? 'collapsed' : 'expanded') + '; path=/; max-age=604800'; // set for 1 week

            setTimeout(function () {
                $aside.trigger('aside:toggle');
            }, 400);
        };

        // sidebar menu toggles
        $('#asideBtn A').click(toggleSidebarMenu);
        $('.aside-search-icon-closed').click(() => {
            toggleSidebarMenu();
            $('#searchTerms').focus();
        });

        // TOGGLE MENU ITEM CONTENT IN MINI SIDEBAR
        $asideNavbar.find('.nav > li > div').click(function () {
            // WORKAROUND FOR LI CHILDREN (DON'T CLOSE ON CLICK)
            $(this).data('clicked', '1');
        });
        $asideNavbar.find('.nav > li').click(function () {
            const $div = $(this).children('div');
            if ($div.data('clicked')) { $div.removeData('clicked'); return; }
            $asideNavbar.find('.nav > li div').not($div).removeClass('active');
            $div.toggleClass('active');
        });
        // OUTER CLICK HANDLER
        $body.click(function () {
            if ($('#aside:hover').length < 1) {
                $asideNavbar.find('.nav > li div').removeClass('active');
            }
        });
        // ONLY ONE DROPDOWN SUBMENU FOR SIDEBAR
        $asideNavbar.find('.drop.collapse').on('show.bs.collapse', function () {
            $asideNavbar.find('.drop.collapse.show').collapse('toggle');
        });

        // scroll menu area to recently expanded item
        const navbarOffsetTop = ($asideNavbar.offset() as JQueryCoordinates).top;
        $asideNavbar.find('.drop.collapse').on('shown.bs.collapse', function () {
            $asideNavbar.scrollTop(<number>$asideNavbar.scrollTop() + ($(this).closest('LI').offset() as JQueryCoordinates).top - navbarOffsetTop);
        });
    }
}
